import { render, staticRenderFns } from "./PromotionTrackingReportExport.vue?vue&type=template&id=57068aa1&scoped=true&"
import script from "./PromotionTrackingReportExport.vue?vue&type=script&lang=js&"
export * from "./PromotionTrackingReportExport.vue?vue&type=script&lang=js&"
import style0 from "./PromotionTrackingReportExport.vue?vue&type=style&index=0&id=57068aa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57068aa1",
  null
  
)

export default component.exports